import axios from 'axios'
import { API } from '../../utils/index'
const instance = axios.create()


export const getTags = async () => {
	const _endpoint = 'tag'
	const URL = `${API}/${_endpoint}`
	return instance.get(URL)
}
